import React from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { UnifiedModal } from "../../components/UnifiedModal";
import { Button as AppButton } from "../../components/Button";

export function ArchiveEventMessagesModal({
  open,
  onClose,
  clientName = "",
  targetMessage = null,
  recommendations = [],
  selectedIds = [],
  onToggleSelection,
  error = "",
  onConfirm,
  isSubmitting = false,
}) {
  const theme = useTheme();

  const selectedCount = selectedIds.length + (targetMessage?.id ? 1 : 0);

  return (
    <UnifiedModal
      open={open}
      onClose={onClose}
      title="Archivar mensaje de evento"
      maxWidth="sm"
      contentSx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          minHeight: 0,
          flex: 1,
        }}
      >
        {clientName ? (
          <Box>
            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 600 }}>
              Cliente:
            </Typography>
            <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
              {clientName}
            </Typography>
          </Box>
        ) : null}

        <Box>
          <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
            Mensaje a archivar:
          </Typography>
          <Box
            sx={{
              p: 1.5,
              borderRadius: "10px",
              border: `1px solid ${theme.palette.divider}`,
              backgroundColor: theme.palette.action.hover,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {targetMessage?.content || "Sin contenido"}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            pr: 0.5,
          }}
        >
          {recommendations.length > 0 ? (
            <Box>
              <Typography variant="body2" sx={{ mb: 1.25, fontWeight: 700 }}>
                Quizás también te interese archivar:
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {recommendations.map((message) => {
                  const isSelected = selectedIds.includes(message.id);

                  return (
                    <Box
                      key={message.id}
                      onClick={() => onToggleSelection(message.id)}
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 1,
                        p: 1,
                        borderRadius: "10px",
                        border: `1px solid ${theme.palette.divider}`,
                        backgroundColor: theme.palette.background.paper,
                        cursor: "pointer",
                      }}
                    >
                      <Checkbox
                        checked={isSelected}
                        onChange={() => onToggleSelection(message.id)}
                        onClick={(event) => event.stopPropagation()}
                        size="small"
                        sx={{ mt: "-4px" }}
                      />
                      <Box sx={{ minWidth: 0, flex: 1 }}>
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                          }}
                        >
                          {message.content || "Sin contenido"}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: theme.palette.text.secondary }}
                        >
                          {new Date(message.created_at).toLocaleString("es-ES")}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          ) : null}
        </Box>

        {error ? (
          <Typography variant="body2" sx={{ color: theme.palette.error.main }}>
            {error}
          </Typography>
        ) : null}

        <Box
          sx={{
            display: "flex",
            gap: 2,
            justifyContent: "flex-end",
            pt: 2,
            borderTop: `1px solid ${theme.palette.divider}`,
          }}
        >
          <AppButton
            variant="outline"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancelar
          </AppButton>
          <AppButton
            variant="default"
            onClick={onConfirm}
            disabled={isSubmitting || !targetMessage?.id}
          >
            {isSubmitting
              ? "Archivando..."
              : selectedIds.length > 0
                ? `Archivar mensajes (${selectedCount})`
                : "Archivar mensaje"}
          </AppButton>
        </Box>
      </Box>
    </UnifiedModal>
  );
}
